// extracted by mini-css-extract-plugin
module.exports = {"button":"TwireButton_button__31Ud-","blue":"TwireButton_blue__3oYlU","red":"TwireButton_red__2DBTg","loadingSvg":"TwireButton_loadingSvg__1GO82"};